import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./authCrud";
import jwt_decode from "jwt-decode";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  RefreshToken: "[Refresh Token] Action"
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  isAdmin: false,
  isProjectManager: false,
  isTechnician: false,
  isWorker: false,
  refreshToken: ''
};

export const reducer = persistReducer(
  { storage, key: "auth-token", whitelist: ["user", "authToken", "isAdmin", "isProjectManager", "isTechnician", "isWorker", "refreshToken"] },
  (state = initialAuthState, action) => {

    switch (action.type) {
      case actionTypes.Login: {
        const { token } = action.payload;
        let roles = jwt_decode(token).role;
        let roleModel = {
          isAdmin: roles.includes("Admin"),
          isProjectManager: roles.includes("Project Manager"),
          isTechnician: roles.includes("Technician"),
          isWorker: roles.includes("Worker")
        }

        console.log("Set the redux init values");
        return { authToken: token, refreshToken: action.payload.refreshToken, user: undefined, ...roleModel };
      }

      case actionTypes.RefreshToken: {
        const { token } = action.payload;
        let roles = jwt_decode(token).role;
        let roleModel = {
          isAdmin: roles.includes("Admin"),
          isProjectManager: roles.includes("Project Manager"),
          isTechnician: roles.includes("Technician"),
          isWorker: roles.includes("Worker")
        }

        console.log("Set the redux init values");
        return { authToken: token, refreshToken: action.payload.refreshToken, user: state.user, ...roleModel };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { ...state, authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;

        return { ...state, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;

        return { ...state, user };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (user) => ({ type: actionTypes.Login, payload: user }),
  refreshToken: (user) => ({ type: actionTypes.RefreshToken, payload: user }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga({ payload }) {
    yield put(actions.requestUser(payload));
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested({ payload }) {
    // const { data: user } = yield getUserByToken();
    yield put(actions.fulfillUser(payload.user));
  });
}
